module.exports = __webpack_public_path__ + "img/list.d70d1660.svg";